import { render, staticRenderFns } from "./AddNewDeposit.vue?vue&type=template&id=6c2d3833&scoped=true&"
import script from "./AddNewDeposit.vue?vue&type=script&lang=ts&"
export * from "./AddNewDeposit.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewDeposit.vue?vue&type=style&index=0&id=6c2d3833&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2d3833",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Volumes/NVME/projects/vbimex/client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
installComponents(component, {VRadio,VRadioGroup})
